import React from 'react';
import { compose } from 'redux';
import { withTranslation, WithTranslation } from 'react-i18next';
import { Url, USER_PROFILE_SECTION_PATHS } from '@wix/da-url';
import {
  withVerification,
  WithVerificationProps,
} from '@wix/da-shared-react/pkg/VerificationPopup/withVerification';
import Feed, { FeedWidgetProps } from './Feed';
import reduxConnectContainer from './Feed.container';
import WidgetBox, { Props as WidgetBoxProps } from '../_partials/WidgetBox';
import EmptyState from '../../EmptyState';

import s from './Feed.scss';

const enhance = compose(
  withVerification,
  reduxConnectContainer,
  withTranslation()
);
class FeedBox extends React.Component<
  FeedWidgetProps &
    WidgetBoxProps &
    WithTranslation &
    WithVerificationProps & {
      isOwner: boolean;
      openSubmitPostPopup: () => void;
    }
> {
  render() {
    const {
      isHeaderStickyOnMobile,
      widgetMoveUp,
      widgetMoveDown,
      widgetRemove,
      isEmpty,
      isOwner,
      openSubmitPostPopup,
      isVerificationNeeded,
      pushVerificationPopup,
      t,
      section,
      zone,
      ...props
    } = this.props;

    return (
      <WidgetBox
        moduleId={props.moduleId}
        section={section}
        zone={zone}
        header={this.props.t!('widgets.feed.header')}
        seeAllUrl={Url.userLink(
          props.profileOwnerUser.username,
          `${USER_PROFILE_SECTION_PATHS.POSTS}`
        )}
        isHeaderStickyOnMobile={isHeaderStickyOnMobile}
        widgetMoveUp={widgetMoveUp}
        widgetMoveDown={widgetMoveDown}
        widgetRemove={widgetRemove}
        isEmpty={isEmpty}
        emptyView={
          isOwner ? (
            <EmptyState
              view="small"
              className={s['empty-state']}
              title={t!('widgets.feed.empty.title.owner')}
              subtitle={t!('widgets.feed.empty.subtitle.owner')}
              buttonLabel={t!('widgets.feed.empty.CTALabel.owner')}
              withButton
              onButtonClick={
                isVerificationNeeded
                  ? () => pushVerificationPopup('submitstatus')
                  : openSubmitPostPopup
              }
            />
          ) : (
            <EmptyState
              view="small"
              className={s['empty-state']}
              title={t!('widgets.feed.empty.title.visitor', {
                username: props.profileOwnerUser.username,
              })}
              subtitle={t!('widgets.feed.empty.subtitle.visitor', {
                username: props.profileOwnerUser.username,
              })}
            />
          )
        }
      >
        <Feed {...props} />
      </WidgetBox>
    );
  }
}

export default enhance(FeedBox) as React.ComponentType<{}>;
